module.exports = __webpack_public_path__ + "1-04.png?00ab7653fda2d8d1691b0ff436f9b488";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-04.png
// module id = 81
// module chunks = 0